import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../app/hooks'
import { associateCurrentEventTask } from '../currentEventTask/currentEventTaskSlice'
import { AddIcon } from "../../images/Icons"
import '../../App.css'

export function AddEventTaskButton() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    return (
        <div className='iconButton' onClick={() => {
            dispatch(associateCurrentEventTask({
                eventTaskType: 0,
                eventTask: {
                    title: '',
                    id: 0,
                    allocatedUserEmail: '',
                    allocatedUserAlias: null,
                    description: '',
                    notes: '',
                    status: 0
                }
            }))
            navigate('/NameEventTask')
        }}>
            <AddIcon />
        </div>
    )
}